import React from 'react'
import { Button, Modal } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import classes from './status-dialog.module.css'

const StatusDialog = ({
  showDialog,
  setShowDialog,
  dialogHeader,
  dialogContent,
}) => (
  <Modal
    open={showDialog}
    centered
    size="small"
    style={{ position: 'relative', height: 'auto' }}
  >
    <Modal.Header className={classes.header} closeButton>
      {dialogHeader}
    </Modal.Header>
    <Modal.Content image style={{ alignItems: 'center', fontSize: '12pt' }}>
      {dialogContent}
    </Modal.Content>
    <Modal.Actions>
      <Button
        type="submit"
        form="deviceAddForm"
        className={classes.postiveStatus}
        onClick={() => setShowDialog(false)}
      >
        OK
      </Button>
    </Modal.Actions>
  </Modal>
)
StatusDialog.propTypes = {
  showDialog: Proptypes.bool.isRequired,
  setShowDialog: Proptypes.func.isRequired,
  dialogHeader: Proptypes.any.isRequired,
  dialogContent: Proptypes.any.isRequired,
}
export default StatusDialog
